module.exports = __webpack_public_path__ + "static/img/back_navbar.b27040e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back_navbar.png
// module id = wduy
// module chunks = 1